import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { DocumentRequest } from '@trustero/trustero-api-web/lib/request/request_pb'
import { useNavigate } from 'react-router-dom'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import {
  BasicDropdownMenu,
  BasicDropdownMenuItem,
} from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { DropdownToggleButton } from 'src/components/Reusable/Buttons'
import { ReactComponent as VerticalEllipsesIcon } from 'src/components/Icons/assets/vertical-ellipses-icon.svg'
import { useDeleteRequestModal } from 'src/pages/Requests/DeleteRequestModal/DeleteRequestModal'

export const RequestItemMenu = ({
  request,
  permalink,
}: {
  request: DocumentRequest
  permalink: string
}): JSX.Element => {
  const requestId = request.getId()
  const navigate = useNavigate()
  const canDeleteRequest = useCanPerformAction<DocumentRequest.AsObject>(
    CAPABILITY.CAN_DELETE_REQUESTS,
    request.toObject(),
  )
  const deleteRequest = useDeleteRequestModal({ request })

  return (
    <Dropdown id={`requests-index-menu-${requestId}`}>
      <Dropdown.Toggle as={DropdownToggleButton}>
        <VerticalEllipsesIcon />
      </Dropdown.Toggle>
      <BasicDropdownMenu $offset={12}>
        <BasicDropdownMenuItem
          eventKey="1"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation()
            e.preventDefault()
            navigate(permalink)
          }}
        >
          View Details
        </BasicDropdownMenuItem>
        {canDeleteRequest && (
          <BasicDropdownMenuItem
            eventKey="2"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation()
              e.preventDefault()
              deleteRequest()
            }}
          >
            Delete Request
          </BasicDropdownMenuItem>
        )}
      </BasicDropdownMenu>
    </Dropdown>
  )
}
